import {
  systemWhite,
  link01,
  link01Inverse,
  backgroundHigh,
  textSecondary,
} from '@bukalapak/bazaar-token';

export default {
  primary: systemWhite,
  secondary: backgroundHigh,
  outline: textSecondary,
  prime: systemWhite,
  naked: link01,
  'naked-inverse': link01Inverse,
  'outline-white': systemWhite,
  blue: systemWhite,
}
